import React from "react";

const GoogleMap = () => {
    return (
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3173.0715548278013!2d126.83828729999999!3d37.317132699999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b6f1b77039a9d%3A0x997519c7855b79b4!2z7KCV7ZmY6rWQ7ZS867aA6rO87J2Y7JuQ!5e0!3m2!1sko!2skr!4v1769155661038!5m2!1sko!2skr"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="정환교 피부과 위치"
        />
    );
};

export default GoogleMap;
